import { render, staticRenderFns } from "./CustomerOrderGrid.vue?vue&type=template&id=499a4563&scoped=true&"
import script from "./CustomerOrderGrid.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderGrid.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrderGrid.vue?vue&type=style&index=0&id=499a4563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a4563",
  null
  
)

export default component.exports